module.exports = __webpack_public_path__ + "img/forbes.9e34c552.png";